
import React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface BrandButtonProps extends ButtonProps {
  gradient?: boolean;
  glassy?: boolean;
  cta?: boolean;
}

/**
 * Button component that follows the VirtuStaff brand guidelines
 */
export const BrandButton = React.forwardRef<HTMLButtonElement, BrandButtonProps>(
  ({ gradient, glassy, cta, className, children, variant = "default", ...props }, ref) => {
    // Set the appropriate variant based on props
    let buttonVariant = variant;
    if (gradient) buttonVariant = "gradient";
    if (glassy) buttonVariant = "glassy";
    if (cta) buttonVariant = "cta";

    return (
      <Button
        ref={ref}
        variant={buttonVariant}
        className={cn(
          "font-semibold transition-all",
          className
        )}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

BrandButton.displayName = "BrandButton";
